export default __webpack_public_path__ + "static/media/discover.70c86658.svg";